import type { IIndexHeader } from "~/utils/interfaces/table-interfaces";

/**
 * Columns of the two attendance tables. Every derivation the review needs lives in
 * `utils/helpers/attendance` — this composable exists for the column config alone.
 */
export const useAttendanceReview = () => {
  /** The single review table: a line read off the sheet, who it is, and the hours to declare. */
  const signatureHeaders: IIndexHeader[] = [
    { name: "Nom lu sur la feuille", minWidthPx: 220, align: "left" },
    { name: "Participant Simbel", minWidthPx: 300, align: "left" },
    { name: "Temps effectué", widthPx: 200, align: "right" },
  ];

  /** The confirm modal: everyone booked whose signature is nowhere on the sheet. */
  const missingHeaders: IIndexHeader[] = [
    { name: "Participants", minWidthPx: 200 },
    { name: "Effectué", widthPx: 150, align: "right" },
  ];

  return { signatureHeaders, missingHeaders };
};
